import { gql } from '@apollo/client';

export const QUERY_LEARN_PAGE = gql`
  query LearnPage {
    learnPage {
      data {
        attributes {
          welcomePageMessage {
            title
            description
          }
          searchSection {
            title
            searchInput
            whatKindTitle
            chooseATopicTitle
            chooseCollectionTitle
            topics {
              data {
                attributes {
                  topic
                }
              }
            }
            themes {
              data {
                attributes {
                  theme
                }
              }
            }
            types {
              type
            }
          }
          emptyInProgressCoursesMessage
          emptyCompletedCoursesMessage
          markLessonAsCompleteButton {
            markAsCompleteLabel
            completedLabel
          }
          markCourseAsCompleted {
            markAsCompleteLabel
            completedLabel
          }
          contentTemplateLabels {
            downloadableContentLabel
          }
        }
      }
    }
  }
`;

export const QUERY_COURSE_FEEDBACK_PAGE = gql`
  query courseFeedbackPage {
    learnPage {
      data {
        attributes {
          markCourseAsCompleted {
            completedLabel
          }
          feedbackSection {
            title
            description
            submitYourFeedback
            enterYourFeedback
            sendFeedback
          }
          modalLeavePage {
            title
            description
            confirmButton
            cancelButton
          }
        }
      }
    }
  }
`;
